import { combineReducers } from "redux";

import {
  LOGOUT_SUCCESS
} from "../actions/session";

import aegean_batch_runs from "./aegean_batch_runs";
import bookmarks from "./bookmarks";
import channels from "./channels";
import custom_categories from "./custom_categories";
import data_functions from "./data_functions";
import data_provider_credentials from "./data_provider_credentials";
import data_regions from "./data_regions";
import env_variables from "./env_variables";
import events from "./events";
import most_interacted_providers from "./most_interacted_providers";
import organization_data_functions from "./organization_data_functions";
import organization_roles from "./organization_roles";
import organization_users from "./organization_users";
import organizations from "./organizations";
import output_fields from "./output_fields";
import production_api_keys from "./production_api_keys";
import public_session_hash from "./public_session_hash";
import regions from "./regions";
import sample_data from "./sample_data";
import session from "./session";
import table_providers from "./table_providers";
import tags from "./tags";
import test_api_keys from "./test_api_keys";
import types from "./types";
import use_cases from "./use_cases";
import whitelisted_ip_addresses from "./whitelisted_ip_addresses";
import workspace from "./workspace";
import workspaces from "./workspaces";

const appReducer = combineReducers({
  aegean_batch_runs,
  bookmarks,
  channels,
  custom_categories,
  data_functions,
  data_provider_credentials,
  data_regions,
  env_variables,
  events,
  most_interacted_providers,
  organization_data_functions,
  organization_roles,
  organization_users,
  organizations,
  output_fields,
  production_api_keys,
  public_session_hash,
  regions,
  sample_data,
  session,
  table_providers,
  tags,
  test_api_keys,
  types,
  use_cases,
  whitelisted_ip_addresses,
  workspace,
  workspaces
});

export default (state, action) => (
  action.type === LOGOUT_SUCCESS
    ? appReducer(undefined, action)
    : appReducer(state, action)
);
